import React, { useState, useEffect } from "react";
import { Result, Typography } from "antd";
import { useIntl } from "react-intl";

import CustomIcon from "../customIcon";
import colors from "../../../../colors";

import "./index.css";

const { Paragraph, Text } = Typography;

const ErrorList = ({ intl, message }) =>
  (
    message ||
    intl.formatMessage({
      id: "messages.unknownError",
      defaultMessage: "neznámá chyba",
    })
  )
    .split(";")
    .map((m, i) => (
      <div key={i} className="consignment-result-list-item">
        <CustomIcon color={colors.RED} marginRight={10} type="warning" />
        {m}
      </div>
    ));

const SaveResult = ({ message, success, templateWork }) => {
  const intl = useIntl();
  const [child, setChild] = useState();
  const [status, setStatus] = useState();
  useEffect(() => {
    if (success && message && !templateWork) {
      setChild(
        <div className="desc">
          <ErrorList intl={intl} message={message} />
        </div>
      );
      setStatus("warning");
    } else if (success || templateWork) {
      setChild();
      setStatus();
    } else {
      setStatus("error");
      setChild(
        <div className="desc">
          <Paragraph>
            <Text strong className="font-16">
              {intl.formatMessage({
                id: "messages.errorTitle",
                defaultMessage: "Selhání bylo způsobeno následující chybou:",
              })}
            </Text>
          </Paragraph>
          <ErrorList intl={intl} message={message} />
        </div>
      );
    }
  }, [intl, message, success, templateWork]);

  return (
    <Result
      status={status || "success"}
      title={
        status === "error"
          ? intl.formatMessage({
              id: "messages.saveFail",
              defaultMessage: "Uložení selhalo",
            })
          : status === "warning"
          ? intl.formatMessage(
              {
                id: "messages.saveFailBut",
                defaultMessage:
                  "Úspěšně uloženo, ale {item} nemá vyplněny všechny povinné parametry!",
              },
              {
                item: (templateWork
                  ? intl.formatMessage({
                      id: "consignment.template.name",
                      defaultMessage: "šablona",
                    })
                  : intl.formatMessage({
                      id: "consignment",
                      defaultMessage: "zásilka",
                    })
                ).toLowerCase(),
              }
            )
          : intl.formatMessage({
              id: "messages.successSave",
              defaultMessage: "Úspěšně uloženo",
            })
      }
    >
      {child}
    </Result>
  );
};

export default SaveResult;
